module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/common/add-sales-sub-channel/add-sales-sub-channel.component.scss
// module id = ./src/app/modules/backstage-module/common/add-sales-sub-channel/add-sales-sub-channel.component.scss
// module chunks = 9